export const globalPromotionsManager = {
  header: {
    title: "Gerenciador de promoções",
    description:
      "Crie e gerencie promoções de estadia para toda a conta. Elas estarão disponíveis para qualquer uma das suas propriedades (apartamentos e hotéis).",
  },

  toolbar: {
    info: "As promoções criadas aqui podem ser ativadas na aba <strong>Promoções</strong> de cada propriedade.",
    newPromotion: "Nova promoção",
  },

  loading: "Carregando promoções...",
  close: "Fechar",
  cancel: "Cancelar",
  noLimit: "Sem limite",

  status: {
    active: "Ativa",
    paused: "Pausada",
  },

  card: {
    stay: "Estadia",
    discount: "Desconto",
    validity: "Validade",
    edit: "Editar",
    delete: "Excluir",
  },

  nights: {
    range: "{min} – {max} noites",
    min: "{min}+ noites",
  },

  discount: {
    fixed: "{value} (fixo)",
  },

  empty: {
    title: "Nenhuma promoção criada",
    description:
      "Crie promoções para incentivar estadias mais longas. Você pode ativá-las em cada propriedade nas configurações de reservas diretas.",
    create: "Criar primeira promoção",
  },

  form: {
    editTitle: "Editar promoção",
    createTitle: "Nova promoção",
    nameLabel: "Nome da promoção",
    namePlaceholder: "ex.: desconto de 7 noites, Oferta semanal",
    minNights: "Noites mínimas",
    maxNights: "Noites máximas",
    optional: "(opcional)",
    noLimitPlaceholder: "Sem limite",
    discountType: "Tipo de desconto",
    percentage: "Percentual",
    fixedAmount: "Valor fixo",
    discountValue: "Valor do desconto",
    amountSuffix: "valor",
    validFrom: "Válida a partir de",
    validTo: "Válida até",
    activateNow: "Ativar promoção imediatamente",
    propertiesLabel: "Propriedades onde estará disponível",
    selectAll: "Selecionar todas",
    propertiesHelper:
      "Serão criados registros de configuração para as propriedades selecionadas.",
    infoBox:
      "Você poderá ajustar depois o selo, a ordem e o comportamento na aba <strong>Promoções</strong> de cada propriedade.",
    saving: "Salvando...",
    update: "Atualizar",
    create: "Criar promoção",
  },

  deleteModal: {
    title: "Excluir promoção",
    warningStrong: "Esta ação não pode ser desfeita.",
    warningBefore: "Você está prestes a excluir a promoção",
    warningAfter: ". Ela não estará mais disponível em nenhuma propriedade.",
    confirmLabel: "Digite o nome exato para confirmar:",
    confirmPlaceholder: "Digite o nome da promoção",
    deleting: "Excluindo...",
    confirmDelete: "Excluir permanentemente",
  },

  toasts: {
    loadError: "Não foi possível carregar as promoções.",
    nameRequired: "Informe um nome para a promoção",
    minNightsWarning: "As noites mínimas devem ser no mínimo 1",
    discountValueWarning: "O valor do desconto deve ser maior que 0",
    selectProperty: "Selecione pelo menos uma propriedade",
    updated: "Promoção atualizada",
    created: "Promoção criada com sucesso",
    saveFailed: "Não foi possível salvar",
    saveError: "Erro ao salvar a promoção",
    deleted: "Promoção excluída",
    deleteFailed: "Não foi possível excluir",
    deleteError: "Erro ao excluir",
  },
};
